import { render, staticRenderFns } from "./Info3.vue?vue&type=template&id=070fa40a&scoped=true&"
import script from "./Info3.vue?vue&type=script&lang=js&"
export * from "./Info3.vue?vue&type=script&lang=js&"
import style0 from "./Info3.vue?vue&type=style&index=0&id=070fa40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070fa40a",
  null
  
)

export default component.exports